import { Status } from '@essent/common';
import { createSelector } from '@ngrx/store';

import { getFlowIdHasError, getFlowIdString } from '../flow/flow-id.selectors';
import { getRetentionState } from '../retention-feature.selector';

export const getSummaryState = createSelector(
  getRetentionState,
  (state) => state.summary
);

export const getSummaryEntry = createSelector(
  getSummaryState,
  getFlowIdString,
  (state, flowId) => (flowId != null ? state.entities[flowId] : undefined)
);

export const getSummary = createSelector(
  getSummaryEntry,
  (entry) => entry?.entry
);

export const getSummaryStatus = createSelector(
  getSummaryEntry,
  (entry) => entry?.status
);

export const getSummaryHasError = createSelector(
  getSummaryStatus,
  getFlowIdHasError,
  (status, hasFlowIdError) => status === Status.ERROR || hasFlowIdError
);

export const isSummaryLoading = createSelector(
  getSummaryStatus,
  getSummaryHasError,
  (status, hasError) =>
    (status === undefined ||
      status === Status.PENDING ||
      status === Status.IDLE) &&
    !hasError
);

export const getSummaryVM = createSelector(
  getSummary,
  getSummaryHasError,
  (summary, hasError) => ({
    summary,
    hasError,
  })
);
